var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { PageLoader, Card, Button } from '@trustpilot/businessapp-patternlibrary';
import { Text, LocalizationProvider } from 'ilenia';
import translations from '../localization/en-US/string.json';
import * as flat from 'flat';
import lookup from 'country-code-lookup';
import { SIGNUP_EMAIL_KEY } from '../Model';
import { metadata } from '@trustpilot/resources';
import '../Styles/login.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendSignUpData } from '../Api/settingsApiClient';
import { Flex, Box } from '../CommonUI/Layout';
import { StyleSheet, css } from 'aphrodite';
import { SignupInfo, Modal, Spinner } from '../CommonUI/Components';
import { Input, Checkbox, BasicDropDown, NotificationBox } from '../CommonUI/Controls';
import * as commonStyles from '../Styles/common';
var Signup = (function (_super) {
    __extends(Signup, _super);
    function Signup(props) {
        var _this = _super.call(this, props) || this;
        _this.recaptchaRef = React.createRef();
        var _a = props.draft ? props.draft : {}, _b = _a.website, website = _b === void 0 ? '' : _b, _c = _a.company, company = _c === void 0 ? '' : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.email, email = _e === void 0 ? '' : _e, _f = _a.phone, phone = _f === void 0 ? '' : _f, _g = _a.country, country = _g === void 0 ? 'US' : _g;
        _this.state = {
            account: { website: website, company: company, name: name, email: email, phone: phone, country: country, password: '' },
            accountError: {},
            passwordValidations: {
                minimumRequiredPasswordLength: undefined,
                lowercaseLetter: undefined,
                uppercaseLetter: undefined,
                number: undefined,
            },
            consents: { trustpilotConsent: false, ecommConsent: false },
            isConsentModalOpen: false,
            signupProcessing: false,
            notification: '',
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onCountryChange = _this.onCountryChange.bind(_this);
        _this.onSignup = _this.onSignup.bind(_this);
        _this.validateMandatory = _this.validateMandatory.bind(_this);
        _this.validateWebsite = _this.validateWebsite.bind(_this);
        _this.validateEmail = _this.validateEmail.bind(_this);
        _this.validatePassword = _this.validatePassword.bind(_this);
        _this.onValidation = _this.onValidation.bind(_this);
        _this.onConsentChange = _this.onConsentChange.bind(_this);
        _this.onCaptchaChange = _this.onCaptchaChange.bind(_this);
        _this.onConsentLinkClicked = _this.onConsentLinkClicked.bind(_this);
        return _this;
    }
    Signup.getDerivedStateFromProps = function (props, state) {
        var _a;
        var draft = props.draft;
        var account = state.account;
        if (draft && !account.website && !account.company && !account.name && !account.email) {
            var _b = draft.website, website = _b === void 0 ? '' : _b, _c = draft.company, company = _c === void 0 ? '' : _c, _d = draft.name, name_1 = _d === void 0 ? '' : _d, _e = draft.email, email = _e === void 0 ? '' : _e, _f = draft.phone, phone = _f === void 0 ? '' : _f, _g = draft.country, country = _g === void 0 ? 'US' : _g;
            var initCountry = lookup.byCountry(country) ? (_a = lookup.byCountry(country)) === null || _a === void 0 ? void 0 : _a.iso2 : country;
            return {
                account: { website: website, company: company, name: name_1, email: email, phone: phone, country: initCountry, password: '' }
            };
        }
        return null;
    };
    Signup.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, simplicityUrl, draftCallback, script, countriesList, countriesFormatted, countriesSorted, countriesWithoutDuplicates;
            return __generator(this, function (_b) {
                _a = this.props, simplicityUrl = _a.simplicityUrl, draftCallback = _a.draftCallback;
                if (draftCallback) {
                    draftCallback('signup_data');
                }
                if (simplicityUrl) {
                    script = document.createElement('script');
                    script.src = simplicityUrl;
                    script.async = true;
                    document.body.appendChild(script);
                }
                countriesList = metadata.getCountries().countries;
                countriesFormatted = countriesList.map(function (_a) {
                    var translatedName = _a.translatedName, country = _a.country;
                    return ({
                        label: translatedName,
                        value: country
                    });
                });
                countriesSorted = countriesFormatted.sort(function (a, b) {
                    return a.label > b.label ? 1 : -1;
                });
                countriesWithoutDuplicates = countriesSorted.filter(function (item, pos, ary) {
                    return !pos || item.value !== ary[pos - 1].value;
                });
                this.setState({ countries: countriesWithoutDuplicates });
                return [2];
            });
        });
    };
    Signup.prototype.onChange = function (field, validationCallback) {
        var _this = this;
        return function (event) {
            var _a = _this.state, account = _a.account, accountError = _a.accountError;
            account[field] = event.target.value;
            delete accountError[field];
            _this.setState({ account: account, accountError: accountError });
            if (validationCallback) {
                validationCallback(event.target.value);
            }
        };
    };
    Signup.prototype.onValidation = function (field, value) {
        this.setState(function (previousState) {
            var accountError = previousState.accountError;
            if (value) {
                accountError[field] = value;
            }
            else {
                delete accountError[field];
            }
            return __assign(__assign({}, previousState), { accountError: accountError });
        });
    };
    Signup.prototype.onCountryChange = function (item) {
        var account = this.state.account;
        account.country = item.value;
        this.setState({ account: account });
    };
    Signup.prototype.onSignup = function (e) {
        e.preventDefault();
        this.setState({ signupProcessing: true });
        var _a = this.state.account, password = _a.password, website = _a.website, email = _a.email;
        var validations = [
            this.validateWebsite(website), this.validateMandatory('website'),
            this.validateMandatory('company'),
            this.validateMandatory('name'),
            this.validateEmail(email), this.validateMandatory('email'),
            this.validateMandatory('phone'),
            this.validateMandatory('country'),
            this.validatePassword(password), this.validateMandatory('password'),
        ];
        if (!validations.every(Boolean)) {
            this.setState({ signupProcessing: false });
            this.props.trackButton({
                placement: 'Bottom',
                action: 'Submit signup data',
                name: 'Submit-signup-data',
                source: this.props.source,
                valid: 'false'
            });
            return;
        }
        if (this.recaptchaRef && this.recaptchaRef.current) {
            this.recaptchaRef.current.execute();
        }
    };
    Signup.prototype.validateMandatory = function (field) {
        var account = this.state.account;
        var isValid = !!account[field];
        if (!isValid) {
            this.onValidation(field, React.createElement(Text, { id: "signup.error.mandatory" }));
        }
        return isValid;
    };
    Signup.prototype.validateWebsite = function (website) {
        var isValid = website ? /^\S+\.\S+$/.test(website.trim()) : true;
        this.onValidation('website', isValid ? '' : React.createElement(Text, { id: "signup.error.website" }));
        return isValid;
    };
    Signup.prototype.validateEmail = function (email) {
        var isValid = email ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()) : true;
        this.onValidation('email', isValid ? '' : React.createElement(Text, { id: "signup.error.email" }));
        return isValid;
    };
    Signup.prototype.validatePassword = function (password) {
        var minimumRequiredPasswordLength = 8;
        var lowercaseLetterPattern = /[a-z]+/g;
        var uppercaseLetterPattern = /[A-Z]+/g;
        var numberPattern = /[0-9]+/g;
        var passwordValidations = {
            minimumRequiredPasswordLength: password ? password.length >= minimumRequiredPasswordLength : undefined,
            lowercaseLetter: password ? lowercaseLetterPattern.test(password) : undefined,
            uppercaseLetter: password ? uppercaseLetterPattern.test(password) : undefined,
            number: password ? numberPattern.test(password) : undefined,
        };
        this.setState({ passwordValidations: passwordValidations });
        return true;
    };
    Signup.prototype.onConsentChange = function (field) {
        var _this = this;
        return function (event) {
            var consents = _this.state.consents;
            consents[field] = event.target.checked;
            _this.setState({ consents: consents });
        };
    };
    Signup.prototype.onCaptchaChange = function (captcha) {
        var _this = this;
        if (captcha) {
            var _a = this.state, account = _a.account, _b = _a.account, password = _b.password, website = _b.website, email = _b.email, country = _b.country;
            var integrationConfig = this.props.integrationConfig;
            var _c = this.getNames(account.name), firstName = _c.firstName, lastName = _c.lastName;
            var simplicity = document.querySelector('input[name="simplicity"]').value;
            var data_1 = {
                signup: {
                    firstName: firstName,
                    lastName: lastName,
                    website: website.trim(),
                    email: email.trim(),
                    companyName: account.company.trim(),
                    country: country,
                    simplicity: simplicity,
                    phone: account.phone.trim(),
                    captcha: captcha,
                    password: password,
                },
                integrationConfig: integrationConfig
            };
            sendSignUpData(this.props.settingsApiUrl, data_1).then(function (res) {
                if (res) {
                    switch (res.errorCode) {
                        case 1001:
                            _this.onValidation('website', React.createElement(Text, { id: "signup.error.domainClaim" }));
                            _this.setState({ signupProcessing: false });
                            break;
                        case 1006:
                            _this.onValidation('website', React.createElement(Text, { id: "signup.error.domainUnclaimable" }));
                            _this.setState({ signupProcessing: false });
                            break;
                        case 1007:
                            _this.onValidation('website', React.createElement(Text, { id: "signup.error.domainInvalid" }));
                            _this.setState({ signupProcessing: false });
                            break;
                        case 1003:
                            _this.setState({ signupProcessing: false });
                            _this.onValidation('email', React.createElement(Text, { id: "signup.error.userExists" }));
                            break;
                        default:
                            if (res.errorCode) {
                                _this.setState({ notification: 'signup.error.unknownError', signupProcessing: false });
                            }
                            else {
                                var onSignup = _this.props.onSignup;
                                if (onSignup) {
                                    _this.props.trackButton({
                                        placement: 'Bottom',
                                        action: 'Submit signup data',
                                        name: 'Submit-signup-data',
                                        source: _this.props.source,
                                        valid: 'true'
                                    });
                                    onSignup(res);
                                }
                                try {
                                    localStorage.setItem(SIGNUP_EMAIL_KEY, data_1.signup.email);
                                }
                                catch (e) { }
                            }
                    }
                }
            });
            if (this.recaptchaRef && this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
        }
    };
    Signup.prototype.onConsentLinkClicked = function (event) {
        var isConsentModalOpen = this.state.isConsentModalOpen;
        this.setState({ isConsentModalOpen: !isConsentModalOpen });
    };
    Signup.prototype.render = function () {
        var _this = this;
        var _a = this.props, locale = _a.locale, source = _a.source;
        var _b = this.state, countries = _b.countries, account = _b.account, _c = _b.account, password = _c.password, country = _c.country, _d = _b.consents, trustpilotConsent = _d.trustpilotConsent, ecommConsent = _d.ecommConsent, accountError = _b.accountError, isConsentModalOpen = _b.isConsentModalOpen, passwordValidations = _b.passwordValidations, signupProcessing = _b.signupProcessing, notification = _b.notification;
        var renderInput = function (field, validate) { return (React.createElement(Input, { id: field, label: React.createElement(Text, { id: "signup." + field }), onChange: _this.onChange(field), value: account[field], errorMessage: accountError[field], validate: validate })); };
        var renderPasswordCaption = function () {
            return (React.createElement("p", { className: css(styles.caption, styles.passwordCaption) },
                React.createElement(Text, { id: "signup.passwordCaption.shouldContain" }),
                Object.keys(passwordValidations).map(function (validation) {
                    return (React.createElement("span", { key: validation, className: css(passwordValidations[validation] === true && styles.valid, passwordValidations[validation] === false && styles.inValid) },
                        React.createElement(Text, { id: "signup.passwordCaption." + validation })));
                })));
        };
        var isFormValid = trustpilotConsent && ecommConsent && Object.keys(accountError).length === 0;
        var legalLink = source === 'Shopify' ? 'https://legal.trustpilot.com/for-businesses/terms-of-use-and-sale-for-businesses-new?refresh=top' : 'https://legal.trustpilot.com/free-terms-and-conditions';
        return (React.createElement(LocalizationProvider, { locale: locale, translations: flat.flatten(translations) },
            React.createElement(Box, { className: css(styles.layout) },
                !countries && React.createElement(PageLoader, null),
                countries && (React.createElement(Card, { className: css(styles.cardWrapper) },
                    React.createElement(Flex, { flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start" },
                        React.createElement(Modal, { isOpen: isConsentModalOpen, header: React.createElement(Text, { id: "signup.consent.modalTitle" }), mainActionButton: {
                                onClick: this.onConsentLinkClicked,
                                children: React.createElement(Text, { id: "signup.consent.modalCloseButton" }),
                            }, onClose: this.onConsentLinkClicked },
                            React.createElement("p", { className: css(styles.consentBody) },
                                React.createElement(Text, { id: "signup.consent.modalBody" }))),
                        React.createElement(SignupInfo, { styles: styles.card }),
                        React.createElement(Box, { className: css(styles.card, styles.form) },
                            React.createElement("form", { onSubmit: this.onSignup },
                                React.createElement("h1", null,
                                    React.createElement(Text, { id: "signup.createAccount" })),
                                notification ? React.createElement(NotificationBox, { text: notification }) : undefined,
                                renderInput('website', this.validateWebsite),
                                renderInput('company'),
                                renderInput('name'),
                                renderInput('email', this.validateEmail),
                                renderInput('phone'),
                                React.createElement(BasicDropDown, { menuItems: countries, onChange: this.onCountryChange, placeholder: React.createElement(Text, { id: "signup.country" }), key: countries.length, initialValue: country }),
                                React.createElement(Input, { id: 'password', label: React.createElement(Text, { id: "signup.password" }), onChange: this.onChange('password', this.validatePassword), value: password, validate: this.validatePassword, type: "password" }),
                                renderPasswordCaption(),
                                React.createElement(Checkbox, { id: "ecommConsent", label: "signup.ecommConsent", onChange: this.onConsentChange('ecommConsent'), checked: ecommConsent, links: [{ href: '#', onClick: this.onConsentLinkClicked, className: css(styles.link) }] }),
                                React.createElement(Checkbox, { id: "trustpilotConsent", label: "signup.trustpilotConsent", onChange: this.onConsentChange('trustpilotConsent'), checked: trustpilotConsent, links: [{ href: legalLink, target: '_blank', className: css(styles.link) }], interpolations: { TRUSTPILOT: source === 'Shopify' ? 'Trustpilot Inc.' : 'Trustpilot A/S' } }),
                                signupProcessing
                                    ? React.createElement(Box, { className: css(styles.spinner) },
                                        React.createElement(Spinner, null))
                                    : (React.createElement(Button, { id: "signup", onClick: this.onSignup, disabled: !isFormValid || signupProcessing, stretch: true, className: css(styles.button) },
                                        React.createElement(Text, { id: "signup.button" }))),
                                React.createElement("input", { type: "hidden", id: "simplicity", name: "simplicity" })))),
                    React.createElement(ReCAPTCHA, { sitekey: "6Ld1ziAUAAAAAOuLX_rY7usRzB6L7If_xw_yp9BU", onChange: this.onCaptchaChange, size: "invisible", ref: this.recaptchaRef }))))));
    };
    Signup.prototype.getNames = function (name) {
        var _a = name.replace(/\s+/g, ' ').split(' '), firstName = _a[0], last = _a.slice(1);
        return {
            firstName: firstName,
            lastName: last.join(' '),
        };
    };
    return Signup;
}(React.Component));
export { Signup };
var styles = StyleSheet.create({
    consentBody: {
        fontSize: '14px',
        fontFamily: '\'TrustpilotDefaultFont\', Arial, sans-serif',
        margin: '0',
        fontWeight: 'normal',
        color: '#292929',
        lineHeight: '1.43',
    },
    spinner: {
        textAlign: 'center',
        marginTop: '15px',
    },
    layout: {
        maxWidth: '1160px',
        fontFamily: '\'TrustpilotDefaultFont\', Arial, sans-serif',
    },
    card: {
        width: '400px',
        margin: 0,
    },
    cardWrapper: {
        border: 'none',
        padding: 0,
    },
    link: {
        fontFamily: '\'TrustpilotDefaultFont\', Arial, sans-serif',
        color: '#368cd7',
        textDecoration: 'none',
    },
    form: {
        padding: '0 50px',
        boxSizing: 'content-box',
        flexShrink: 0,
    },
    caption: {
        fontSize: '12px',
        letterSpacing: '0.3px',
        lineHeight: '1.5',
    },
    signUpCaption: {
        color: '#353535',
        marginTop: '15px',
    },
    button: __assign(__assign({}, commonStyles.button), { marginTop: '16px' }),
    passwordCaption: {
        'color': '#91989c',
        'display': 'inline-block',
        'paddingLeft': '15px',
        'margin': '15px 0 6px 0',
        ':before': {
            width: '6px',
            height: '6px',
            borderRadius: '3px',
            boxShadow: 'inset 0 1px 2px 0 rgba(252, 76, 93, 0.4)',
            backgroundColor: '#91989c',
            display: 'inline-block',
            content: '""',
            position: 'absolute',
            transform: 'translate(-15px, 4px)',
        }
    },
    valid: {
        color: '#00b67a',
    },
    inValid: {
        color: '#ff0000',
    },
});
